<template>
    <!-- Page Header-->
    <Header :title="title" :subtitle="subtitle" />
    <!-- Main Content-->
    <main>
        <div class="container px-4 px-lg-5">
            <div class="row gx-4 gx-lg-5 justify-content-center">
                <div class="col-md-10 col-lg-8 col-xl-8" v-if="closet">
                    <el-card style="margin-bottom: 2rem;">
                        <p style="margin:0rem">展示方式</p>
                        <el-radio-group v-model="display" @change="handleDisplayChange" style="padding-bottom: 1rem;">
                            <el-radio value="1" size="large">展示全部</el-radio>
                            <el-radio value="2" size="large">按角色筛选</el-radio>
                            <el-radio value="3" size="large">按paro筛选</el-radio>
                        </el-radio-group>
                        <!-- <el-switch v-model="display" active-text="展示全部" inactive-text="按角色筛选" :active-value="true"
                            :inactive-value="false" @change="handleDisplayChange" style="padding-bottom: 1rem;">
                        </el-switch> -->
                        <div v-if="charaVisible">
                            <el-select v-model="currentChara" clearable placeholder="按角色筛选"
                                style="width: 50%;padding-top:1rem" @change="handleSelectChange">
                                <el-option v-for="item in charaList" :key="item.id" :label="item.name"
                                    :value="item.name" />
                            </el-select>
                        </div>
                        <div v-if="paroVisible">
                            <el-select v-model="currentParo" clearable placeholder="按paro筛选"
                                style="width: 50%;padding-top:1rem" @change="handleSelectChange">
                                <el-option v-for="item in paroList" :key="item.id" :label="item.name"
                                    :value="item.name" />
                            </el-select>
                        </div>
                    </el-card>
                    <div v-if="pageVisible">
                        <div v-if="charaVisible">
                            <h2><a :href="'/chara/' + currentChara + '/closet'">{{ currentChara }}</a></h2>
                            <el-row>
                                <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6" style="display: flex; flex-wrap: wrap;"
                                    v-for="item in closet.closetInfo">
                                    <el-card shadow="hover" :body-style="{ padding: '0px' }"
                                        style="text-align: center;">
                                        <template #footer>{{ item.diff ? item.age + "-" + item.name + "-" +
                                            item.diff : item.age + "-" + item.name }}</template>
                                        <el-image shadow="hover" style="width: 100%;"
                                            :src="'http://img.helloworldend.top/closet/' + item.image" :zoom-rate="1.2"
                                            :max-scale="7" :min-scale="0.2" :preview-src-list="closet.gallery"
                                            show-progress :initial-index="Number(item.sort) - 1" fit="cover" />
                                    </el-card>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                    <div v-if="waterfallVisible">
                        <!-- <div class="checkbox-container">
                            <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate"
                                @change="handleCheckAllChange">显示全部</el-checkbox>
                            <el-checkbox-group v-model="checkedWorlds" @change="handleCheckedWorldsChange">
                                <el-checkbox v-for="world in worlds" :key="world" :label="world">{{ world
                                    }}</el-checkbox>
                            </el-checkbox-group>
                            <el-checkbox-group v-model="checkedSexes" @change="handleCheckedSexesChange">
                                <el-checkbox v-for="sex in sexes" :key="sex" :label="sex">{{ sex }}</el-checkbox>
                            </el-checkbox-group>
                        </div> -->
                        <div v-if="closetList">
                            <div v-for="(c, index) in closetList" :key="index">
                                <h2><a :href="'/chara/' + c.name + '/closet'">{{ c.name }}</a></h2>
                                <el-row>
                                    <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6"
                                        style="display: flex; flex-wrap: wrap;" v-for="item in c.closetInfo">
                                        <el-card shadow="hover" :body-style="{ padding: '0px' }">
                                            <template #footer>{{ item.diff ? item.age + "-" + item.name + "-" +
                                                item.diff : item.age + "-" + item.name }}</template>
                                            <el-image shadow="hover" style="width: 100%"
                                                :src="'http://img.helloworldend.top/closet/' + item.image"
                                                :zoom-rate="1.2" :max-scale="7" :min-scale="0.2"
                                                :preview-src-list="c.gallery" show-progress
                                                :initial-index="Number(item.sort) - 1" fit="cover" />
                                        </el-card>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </div>
                    <div v-if="paroVisible">
                        <h2>{{ currentParo }}</h2>
                        <div v-if="closetList">
                            <el-row>
                                <template v-for="(c, index) in closetList" :key="index">
                                    <template v-for="item in c.closetInfo">
                                        <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6"
                                            style="display: flex; flex-wrap: wrap;"
                                            v-if="item.name.includes(currentParo)">
                                            <el-card shadow="hover" :body-style="{ padding: '0px' }">
                                                <template #footer>{{ item.diff ? c.name + "-" + item.age + "-" +
                                                    item.name +
                                                    "-" +
                                                    item.diff : c.name + "-" + item.age + "-" + item.name }}</template>
                                                <el-image shadow="hover" style="width: 100%"
                                                    :src="'http://img.helloworldend.top/closet/' + item.image"
                                                    :zoom-rate="1.2" :max-scale="7" :min-scale="0.2"
                                                    :preview-src-list="c.gallery" show-progress
                                                    :initial-index="Number(item.sort) - 1" fit="cover" />
                                            </el-card>
                                        </el-col>
                                    </template>
                                </template>
                            </el-row>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script setup>
import Header from '../components/Header.vue'
import { onMounted, ref } from 'vue'
import service from '../utils/request'
import { useCache } from '../utils/usecache'

const title = '服设'
const subtitle = '画不完了……'

const allChara = ref()
const allChara_t = ref()

const charaList = ref()

const checkAll = ref(false)
const isIndeterminate = ref(true)
const checkedWorlds = ref(['泰尔兰', '<人世>', '其他'])
const worlds = ['泰尔兰', '<人世>', '其他']
const checkedSexes = ref(['男', '女'])
const sexes = ['男', '女']
const currentChara = ref('越明')
const currentParo = ref('女仆装')
const chara = ref()
const chara_t = ref()
const charaVisible = ref(false)
const display = ref("2")
const waterfallVisible = ref(false)
const pageVisible = ref(true)
const paroVisible = ref(false)
const closetList = ref()
const paroList = ref([{ id: 1, name: "女仆装" }, { id: 2, name: "睡衣" }, { id: 3, name: "校服" },
{ id: 6, name: "if线" }, { id: 4, name: "古风pa" }, { id: 5, name: "泰尔兰pa" }, { id: 6, name: "异常pa" }])
const allCloset = ref()
const closet = ref()

const handleCheckAllChange = val => {
    checkedSexes.value = val ? sexes : []
    checkedWorlds.value = val ? worlds : []
    isIndeterminate.value = false
    if (val) {
        charaList.value = allChara.value
    } else {
        charaList.value = []
    }
}

const handleCheckedWorldsChange = value => {
    const checkedCount = value.length
    checkAll.value = checkedCount === worlds.length
    isIndeterminate.value = checkedCount > 0 && checkedCount < worlds.length
    let rst = []
    let rst_t = []
    for (let i = 0; i < allChara.value.length; i++) {
        if (value.indexOf(allChara.value[i][0]['world']) !== -1) {
            rst.push(allChara.value[i])
            rst_t.push(allChara_t.value[i])
        }
    }
    charaList.value = rst

}
const handleCheckedSexesChange = value => {
    const checkedCount = value.length
    checkAll.value = checkedCount === sexes.length
    isIndeterminate.value = checkedCount > 0 && checkedCount < sexes.length
    let rst = []
    let rst_t = []
    for (let i = 0; i < allChara.value.length; i++) {
        if (value.indexOf(allChara.value[i][0]['sex']) !== -1) {
            rst.push(allChara.value[i])
            rst_t.push(allChara_t.value[i])
        }
    }
    charaList.value = rst
}

const handleSelectChange = (value) => {
    getCurrentChara(value)
}

const getCharaList = async () => {
    try {
        const rst = await useCache('charaListList', () => {
            return service.get("/user/chara/listList").then(res => res.data)
        })
        if (rst?.length && rst[0] != null) {
            charaList.value = rst
            allChara.value = rst
            getAllChara();
        } else {
            console.error('返回角色信息为空')
        }
    } catch (error) {
        console.error('获取角色信息失败', error)
    }
}


const getCurrentChara = (name) => {
    const params = {
        name: name
    };
    service.get("/user/closet/listCloset", { params })
        .then(res => {
            const rst = res.data;
            if (rst.length != 0 && rst[0] != null) {
                for (let i = 0; i < rst.length; i++) {
                    const images = Object.values(require.context("img", true, /.*/).keys());
                    for (let j = 0; j < images.length; j++) {
                        if (images[j].includes(rst[i].image)) {
                            let q = images[j].replace(/^.\//, '');
                            rst[i].image = require(`img/${q}`);
                        }
                    }
                }
                rst.sort((a, b) => a.sort - b.sort);
                const gallery = rst.map(item => 'http://img.helloworldend.top/closet/' + item.image);
                const closetInfo = {};
                rst.forEach(item => {
                    const name = item.age + item.name;
                    if (!closetInfo[name]) {
                        closetInfo[name] = [];
                    }
                    closetInfo[name].push(item);
                });
                closet.value = { closetInfo: rst, gallery: gallery }
                charaVisible.value = true;
            } else {
                console.error('返回服设信息为空', error);
            }
        }).catch(error => {
            console.error('获取服设信息失败', error);
        });
}

const getAllChara = () => {
    const params = {
        name: 'all'
    };
    service.get("/user/closet/listCloset", { params })
        .then(res => {
            const rst = res.data;
            if (rst.length != 0 && rst[0] != null) {
                for (let i = 0; i < rst.length; i++) {
                    const images = Object.values(require.context("img", true, /.*/).keys());
                    for (let j = 0; j < images.length; j++) {
                        if (images[j].includes(rst[i].image)) {
                            let q = images[j].replace(/^.\//, '');
                            rst[i].image = require(`img/${q}`);
                        }
                    }
                }
                const result = Object.values(
                    rst.reduce((groupMap, item) => {
                        const groupKey = item.charaId;
                        groupMap[groupKey] = groupMap[groupKey] || [];
                        groupMap[groupKey].push(item);
                        return groupMap;
                    }, {})
                ).map(subArray =>
                    subArray.sort((a, b) => a.sort - b.sort)
                );
                let all = []
                for (let i = 0; i < result.length; i++) {
                    let nameObj = charaList.value.find(item => item.id === result[i][0].charaId);
                    let name = nameObj ? nameObj.name : undefined;
                    let gallery = result[i].map(item => 'http://img.helloworldend.top/closet/' + item.image);
                    all.push({ name: name, closetInfo: result[i], gallery: gallery })
                }
                closetList.value = all;
                allCloset.value = all;
            } else {
                console.error('返回服设信息为空', error);
            }
        }).catch(error => {
            console.error('获取服设信息失败', error);
        });
}

onMounted(() => {
    getCharaList()
    getCurrentChara(currentChara.value)
})

const handleDisplayChange = value => {
    if (value == "1") {
        waterfallVisible.value = true;
        pageVisible.value = false;
        charaVisible.value = false;
        paroVisible.value = false;
    } else if (value == "2") {
        waterfallVisible.value = false;
        pageVisible.value = true;
        charaVisible.value = true;
        paroVisible.value = false;
    } else if (value == "3") {
        waterfallVisible.value = false;
        pageVisible.value = true;
        charaVisible.value = false;
        paroVisible.value = true;
    }
}

</script>
<style scoped></style>
